var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "220px" },
            attrs: {
              size: "mini",
              clearable: "",
              placeholder: "请输入模板名称",
            },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.handleFilter($event)
              },
            },
            model: {
              value: _vm.listQuery.templateName,
              callback: function ($$v) {
                _vm.$set(
                  _vm.listQuery,
                  "templateName",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "listQuery.templateName",
            },
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "160px", "margin-left": "10px" },
              attrs: {
                size: "mini",
                clearable: "",
                placeholder: "请选择范围类型",
              },
              on: { change: _vm.handleDeliveryTypeChange },
              model: {
                value: _vm.listQuery.deliveryType,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "deliveryType", $$v)
                },
                expression: "listQuery.deliveryType",
              },
            },
            [
              _c("el-option", { attrs: { label: "平台配送", value: 1 } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "商家自配送", value: 2 } }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "160px", "margin-left": "10px" },
              attrs: {
                size: "mini",
                clearable: "",
                placeholder: "请选择配送渠道",
              },
              model: {
                value: _vm.listQuery.deliveryChannel,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "deliveryChannel", $$v)
                },
                expression: "listQuery.deliveryChannel",
              },
            },
            [
              _c("el-option", { attrs: { label: "达达", value: 1 } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "顺丰", value: 2 } }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "160px", "margin-left": "10px" },
              attrs: {
                size: "mini",
                clearable: "",
                placeholder: "请选择配送方式",
              },
              model: {
                value: _vm.listQuery.deliveryMethod,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "deliveryMethod", $$v)
                },
                expression: "listQuery.deliveryMethod",
              },
            },
            [
              _c("el-option", { attrs: { label: "立即送出", value: 1 } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "预约配送", value: 2 } }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              staticStyle: { "margin-left": "10px" },
              attrs: { type: "primary", icon: "el-icon-search", size: "mini" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v("\n        查询\n      ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: { click: _vm.handleReset },
            },
            [_vm._v("\n        重置\n      ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "has-permi",
                  rawName: "v-has-permi",
                  value: ["admin:merchant:shipping:template:save"],
                  expression: "['admin:merchant:shipping:template:save']",
                },
              ],
              staticClass: "filter-item",
              staticStyle: { "margin-left": "10px" },
              attrs: { type: "primary", icon: "el-icon-plus", size: "mini" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v("\n        添加\n      ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            "element-loading-text": "Loading",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", label: "ID", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n          " + _vm._s(scope.row.id) + "\n        "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "模板名称", align: "center", "min-width": "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.templateName))])]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "范围类型", width: "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.deliveryTypeName))]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "配送渠道", align: "center", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.deliveryChannelName || "—")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "最大配送半径(km)", align: "center", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.maxDeliveryRadius))]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "免配送半径(km)", align: "center", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.freeDeliveryRadius))]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "免配送门槛(元)", align: "center", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.freeDeliveryThreshold)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "配送方式", align: "center", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.deliveryMethodsText))]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "排序", align: "center", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.sort))])]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            directives: [
              {
                name: "has-permi",
                rawName: "v-has-permi",
                value: ["admin:merchant:shipping:template:status"],
                expression: "['admin:merchant:shipping:template:status']",
              },
            ],
            attrs: { label: "状态", align: "center", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: scope.row.status === 1 ? "success" : "danger",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.statusName) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "创建时间", align: "center", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.createTime))])]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "最后更新时间", align: "center", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.updateTime))])]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              align: "center",
              width: "150",
              "class-name": "small-padding fixed-width",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "has-permi",
                            rawName: "v-has-permi",
                            value: ["admin:merchant:shipping:template:update"],
                            expression:
                              "['admin:merchant:shipping:template:update']",
                          },
                        ],
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(row)
                          },
                        },
                      },
                      [_vm._v("\n            编辑\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "has-permi",
                            rawName: "v-has-permi",
                            value: ["admin:merchant:shipping:template:delete"],
                            expression:
                              "['admin:merchant:shipping:template:delete']",
                          },
                        ],
                        attrs: { size: "mini", type: "danger" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(row)
                          },
                        },
                      },
                      [_vm._v("\n            删除\n          ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        staticStyle: { "margin-top": "20px", "text-align": "center" },
        attrs: {
          "page-sizes": [10, 20, 30, 40],
          "page-size": _vm.listQuery.limit,
          "current-page": _vm.listQuery.page,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _vm._v(" "),
      _c("delivery-form-dialog", {
        attrs: {
          visible: _vm.dialogFormVisible,
          "form-data": _vm.formData,
          "dialog-status": _vm.dialogStatus,
        },
        on: {
          "update:visible": function ($event) {
            _vm.dialogFormVisible = $event
          },
          refresh: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }